import { createProvider } from '@nvision/services/data-provider';

import type { TariffTypeFilters } from '../../models';
import * as api from './api';
import { normalizeTariffTypeFilters, normalizeTariffTypes } from './normalize';

export const fetchTariffTypes = createProvider(
  (filters: Partial<TariffTypeFilters>, { signal }: { signal?: AbortController['signal'] } = {}) =>
    api.fetchTariffTypes(normalizeTariffTypeFilters(filters), { signal }),
).andThen((res) => normalizeTariffTypes(res));
